import _ from 'underscore';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useCallback, useMemo } from 'react';
import { Input, Select } from '@bingads-webui-react/primitive';
import { withValidation, withError } from '@bingads-webui-react/validation';
import { PROTOCOLS } from '../constants';

function parseWebsite(website) {
  const result = /^(https?:\/\/)(.*)/i.exec(website);
  const [, selectedProtocol = 'https://', finalUrl = ''] = result || [];

  return [selectedProtocol && selectedProtocol.toLowerCase(), finalUrl];
}

export const WebsitePure = (props) => {
  const {
    id,
    className,
    value,
    onChange,
  } = props;

  const [selectedProtocol, finalUrl] = useMemo(() => (
    parseWebsite(value)
  ), [value]);

  const handleChange = useCallback((protocol, url) => {
    onChange({ target: { value: protocol + url } });
  }, [onChange]);

  const handleSelectedProtocolChange = useCallback(({
    target: { value: protocal },
  }) => {
    handleChange(protocal, finalUrl);
  }, [finalUrl, handleChange]);

  const handleFinalUrlChange = useCallback(({
    target: { value: url },
  }) => {
    handleChange(selectedProtocol, url);
  }, [selectedProtocol, handleChange]);

  return (
    <div className={classNames(className, 'website')}>
      <Select
        id={id && `${id}-selected-protocol`}
        className="select left"
        value={selectedProtocol}
        onChange={handleSelectedProtocolChange}
      >
        <option value={PROTOCOLS.HTTP}>{PROTOCOLS.HTTP}</option>
        <option value={PROTOCOLS.HTTPS}>{PROTOCOLS.HTTPS}</option>
      </Select>
      <Input
        id={id && `${id}-final-url`}
        className="text right"
        value={finalUrl}
        onChange={handleFinalUrlChange}
      />
    </div>
  );
};

WebsitePure.propTypes = {
  id: PropTypes.string,
  className: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
};

WebsitePure.defaultProps = {
  id: null,
  className: null,
  value: null,
  onChange: _.noop,
};

export const Website = withError(withValidation(WebsitePure));
